<template>
  <div>
    <a href="#" class="d-block">
      <img
        class="img-fluid mb-3 border border-dark "
        src="/assets/images/soybean.jpg"
        alt=""
      />
    </a>
    <a href="#" class="btn btn-black btn-pill py-3 px-3">Plan out Inventory</a>
    <p class="my-4 px-3">
      Will you be needing this produce supplied to you consistently? The
      inventory managment tool helps you plan out all of your raw material needs
      for this produce.
    </p>
    <p>
      <font-awesome-icon :icon="['fas', 'headphones-alt']" size="2x" />
      <span class="h6"> +234 813 486 0483</span>
    </p>
  </div>
</template>

<script>
export default {};
</script>
